

/**
* @summary - Component that Provides Asset Catgeory Creation Page
* @author Aro J
* @since 2024-08-13
*/
import React, { useState, useEffect, useRef } from "react";
import { Box, Typography, IconButton, Grid } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { BreadcrumbBar } from "../../assets/styled-components/breadcrumbBar";
import CustomTextField from "../commoncomponents/CustomTextField";
import { DefaultCard } from "../../assets/styled-components/card";
import CustomFooter from "../commoncomponents/CustomFooter";
import { useNavigate, useLocation } from "react-router";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import axios from "axios";
import { MasterGraph, FemsGraph } from '../../utility/apiURLS';
import { getAuthToken, getcompanyId, getFacilityId, getCreatedBy, getModifiedBy } from "../../utility/tokenUtility";
import CustomDialog from "../commoncomponents/CustomDialog";
import HomeIconButton from "../commoncomponents/HomeIconButton";
import PageTitle from "../commoncomponents/PageTitle";
import { TabContext, TabList, TabPanel } from '@mui/lab';
import AttachmentFemsTechDrawing from "./AttachmentFemsTechDrawing";
import { Tabs, Tab } from '@mui/material';
import { set } from "date-fns";

const CreateFemsDrawing = () => {
  //  const [tabValue, setTabValue] = useState(0);
  const navigate = useNavigate();
  const locationarea = useLocation();
  const [referenceno, setReferenceno] = useState('');
  const [Technicalcategory, setServiceOptions] = useState([]);
  const [Technicaltype, setAnotherOptions] = useState([]);
  const [description, setDescription] = useState('');

  const [location, setLocation] = useState('');
  const [contactperson, setContactperson] = useState('');
  const [telephoneno, setTelephoneno] = useState('');
  const [email, setEmail] = useState('');
  const [technicalcategory, setCategory] = useState({
    id: 1,
    label: "Drawing",
    value: "Drawing"
  });
  const [technicaltype, setType] = useState('');

  const [technicalType2, setTechnicalType2] = useState('')
  const [technicalcategory2, setTechnicalcategory2] = useState('')
  const [description2, setDescription2] = useState('');

  const [id, setId] = useState('');
  const [openValidationDialog, setOpenValidationDialog] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [dialogContent, setDialogContent] = useState('');
  const [isAddNew, setIsAddNew] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [readOnlyEdit, setReadOnlyEdit] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isView, setIsView] = useState(false);
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [cancelDialogOpenTab, setCancelDialogOpenTab] = useState(false);

  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const serviceRef = useRef(null);
  const descRef = useRef(null);
  const [rowData, setRowData] = useState({});
  const [tabValue, setTabValue] = useState('1');
  const [options, setOptions] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);

  const [femsTechId, setFemsTechId] = useState('');
  const [defaultValue, setDefaultValue] = useState(null);

  const [errors, setErrors] = useState({
    referenceno: false,
    description: false,
    location: false,
    contactperson: false,
    telephoneno: false,
    email: false,
    technicalcategory: false,
    technicaltype: false,
  });

  const [errorMessages, setErrorMessages] = useState({
    referenceno: '',
    description: '',
    location: '',
    contactperson: '',
    telephoneno: '',
    email: '',
    technicalcategory: '',
    technicaltype: '',
  });

  const token = getAuthToken("id_token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const facilityid = getFacilityId('facilityid');
  const createdBy = getCreatedBy('createdBy');

  useEffect(() => {

    if (locationarea.state) {
  
      const {
        referenceno, location, description, contactperson, telephoneno, email, technicaltype, femtechnicalcategory, id,
        readOnly, readOnlyEdit, mode, technicalcategoryId, femtechnicaltypeId

      } = locationarea.state;

      let techCat = {
        id: technicalcategoryId,
        label: femtechnicalcategory,
        value: femtechnicalcategory
      }
      let techType = {
        id: femtechnicaltypeId,
        label: technicaltype,
        value: technicaltype
      }
  
      setCategory(techCat);
      setReferenceno(referenceno);
      setDescription(description);
      setLocation(location);
      setContactperson(contactperson);
      setTelephoneno(telephoneno);
      setEmail(email);
      setTechnicalType2(techType.label)
      setTechnicalcategory2(techCat.label)
      setDescription2(description);
      //  setCategory(technicalcategory);
      setType(techType);
      setId(id);

      setReadOnly(!!readOnly);
      setReadOnlyEdit(!!readOnlyEdit);
      if (mode === "edit") {
        setIsEdit(true);
        setIsView(false);
      } else if (mode === "view") {
        setIsView(true);
        setIsEdit(false);
      } else {
        setIsEdit(false);
        setIsView(false);
      }
    }

    fetchServiceOptions();
    fetchAnotherServiceOptions();
  }, [locationarea.state]);


  const fetchServiceOptions = async () => {

    try {
      const response = await axios.get(`${FemsGraph}/api/femtechnicalcategories`, config);
      const filteredOptions = response.data
    
      // Set the service options
      const options = filteredOptions.map(option => ({
        label: option.technicalcategory,
        value: option.technicalcategory,
        id: option.id
      }));
      setServiceOptions(options);
      // Check if any option has id == 1
    } catch (error) {
      console.error("Error fetching service options:", error);
    }
  };


  const fetchAnotherServiceOptions = async () => {
    try {

      const response = await axios.get(`${FemsGraph}/api/femtechnicaltypes`, config);
     
      setOptions(response.data.map(option => ({
        label: option.technicaltype,
        value: option.technicaltype,
        id: option.id,
        ...option
      })));


    } catch (error) {
      console.error("Error fetching license type options:", error);
    }
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    let formIsValid = true;

    if (!referenceno) {
      formIsValid = false;
      setErrors((prevErrors) => ({ ...prevErrors, referenceno: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, referenceno: 'Reference No is required' }));


    }

    if (!description) {
      formIsValid = false;
      setErrors((prevErrors) => ({ ...prevErrors, description: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, description: 'Description is required' }));

    }
    if (!location) {
      formIsValid = false;
      setErrors((prevErrors) => ({ ...prevErrors, location: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, location: 'Location is required' }));
    }
    if (!contactperson) {
      formIsValid = false;
      setErrors((prevErrors) => ({ ...prevErrors, contactperson: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, contactperson: 'Contact Person is required' }));

    }
    if (!telephoneno) {
      formIsValid = false;
      setErrors((prevErrors) => ({ ...prevErrors, telephoneno: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, telephoneno: 'Telephone No is required' }));

    }

    if (!Object.values(errorMessages).every(value => value === '')) {
      formIsValid = false
    }

    if (formIsValid) {
      handleSave();
    }
  };


  const handleCancel = () => {
    if (!isChanged) {
      navigate(-1, { replace: true });
    }
    else {
      setCancelDialogOpen(true)
      setDialogContent("Record(s) not Saved/Updated. Do you want to continue?")
    }
  };
  const formData = {
    referenceno,
    description,
    location,
    contactperson,
    telephoneno,
    email,
    technicalcategory,
    technicaltype,

  }
  const handleNumericValue = (value) => {
    // Remove all non-numeric characters
    const regex = /[^0-9+-]/g;
    let numericValue = value?.replace(regex, '') || "";

    // Limit to a maximum of 13 numbers
    if (numericValue?.length > 13) {
      numericValue = numericValue?.slice(0, 13);
    };
    return numericValue;
  };
  const areAllEmpty = () => {
    for (const key in formData) {
      if (Array.isArray(formData[key])) {
        if (formData[key].length !== 0) {
          return false;
        }
      } else if (formData[key]) {
        return false;
      }
    }
    return true;
  };
  const handleAddNew = () => {
    if (isChanged && !areAllEmpty()) {
      setIsAddNew(true);
      setCancelDialogOpen(true);
      setDialogContent("Record(s) not Saved/Updated. Do you want to continue?");
    } else {
      handleAdd();
    }
  };
  const handleCancelDialogClose = () => {
    setCancelDialogOpen(false);
  };

  const handleCancelDialogCloseTab = () => {
    setCancelDialogOpenTab(false);
  };

  const handleConfirmCancel = () => {
    setCancelDialogOpen(false)
    setOpenValidationDialog(false)
    if (isAddNew) {
      handleAdd()
      setIsAddNew(false)
      setIsChanged(false)
    }

    if (isChanged && !isAddNew && !openValidationDialog) {
      setCancelDialogOpen(false);
      navigate(-1, { replace: true });
    }

  };
  const handleConfirmCancelTab = () => {
    setCancelDialogOpenTab(false)
    setOpenValidationDialog(false)
    if (isAddNew) {
      handleAdd()
      setIsAddNew(false)
      setIsChanged(false)
    }

    // if (!isChanged && isAddNew && openValidationDialog) {
    //   setCancelDialogOpenTab(false);
    //   navigate(-1, { replace: true });
    // }

  };



  const handleDialogClose = () => {
    if (isChanged) {
      setOpenValidationDialog(false);
    }
    if (isAddNew) {
      setIsAddNew(false);
    }
    setCancelDialogOpen(false);
    setOpenValidationDialog(false)
  };
  const handlereferencenoChange = (newValue) => {
    setIsChanged(true);
    setReferenceno(newValue);

    const regex = /^[a-zA-Z0-9 /-]*$/;

    if (!regex.test(newValue)) {
      setErrors((prevErrors) => ({ ...prevErrors, referenceno: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, referenceno: 'Invalid Characters in Reference No' }));
    } else if (newValue.startsWith(' ')) {
      setErrors((prevErrors) => ({ ...prevErrors, referenceno: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, referenceno: 'Space not allowed at the beginning' }));
    } else if (newValue.endsWith(' ')) {
      setErrors((prevErrors) => ({ ...prevErrors, referenceno: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, referenceno: 'Space not allowed at the end' }));
    } else if (newValue.includes('  ')) {
      setErrors((prevErrors) => ({ ...prevErrors, referenceno: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, referenceno: 'Double Space not allowed' }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, referenceno: false }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, referenceno: '' }));
    }
  };

  const handledescriptionChange = (newValue) => {
    setIsChanged(true);
    setDescription(newValue);

    const regex = /^[a-zA-Z0-9,!@#$%&*()_\- ]*$/;
    if (!regex.test(newValue)) {
      setErrors((prevErrors) => ({ ...prevErrors, description: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, description: 'Invalid Characters in Description' }));
    } else if (newValue.startsWith(' ')) {
      setErrors((prevErrors) => ({ ...prevErrors, description: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, description: 'Space not allowed at the beginning' }));
    }
    else if (newValue.endsWith(' ')) {
      setErrors((prevErrors) => ({ ...prevErrors, description: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, description: 'Space not allowed at the end' }));
    }

    else if (newValue.includes('  ')) {
      setErrors((prevErrors) => ({ ...prevErrors, description: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, description: 'Double Space not allowed' }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, description: false }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, description: '' }));
    }
  };

  const handlelocationChange = (newValue) => {
    setIsChanged(true);
    setLocation(newValue);

    const regex = /^[a-zA-Z0-9,!@#$%&*()_\- ]*$/;

    if (!regex.test(newValue)) {
      setErrors((prevErrors) => ({ ...prevErrors, location: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, location: 'Invalid Characters in Location' }));
    } else if (newValue.startsWith(' ')) {
      setErrors((prevErrors) => ({ ...prevErrors, location: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, location: 'Space not allowed at the beginning' }));
    }
    else if (newValue.endsWith(' ')) {
      setErrors((prevErrors) => ({ ...prevErrors, location: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, location: 'Space not allowed at the end' }));
    }
    else if (newValue.includes('  ')) {
      setErrors((prevErrors) => ({ ...prevErrors, location: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, location: 'Double Space not allowed' }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, location: false }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, location: '' }));
    }
  };
  const handlecontactpersonChange = (newValue) => {
    setIsChanged(true);
    setContactperson(newValue);

    const regex = /^[a-zA-Z0-9 -]*$/;

    if (!regex.test(newValue)) {
      setErrors((prevErrors) => ({ ...prevErrors, contactperson: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, contactperson: 'Invalid Characters in Contact Person' }));
    } else if (newValue.startsWith(' ')) {
      setErrors((prevErrors) => ({ ...prevErrors, contactperson: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, contactperson: 'Space not allowed at the beginning' }));
    }
    else if (newValue.endsWith(' ')) {
      setErrors((prevErrors) => ({ ...prevErrors, contactperson: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, contactperson: 'Space not allowed at the end' }));
    }

    else if (newValue.includes('  ')) {
      setErrors((prevErrors) => ({ ...prevErrors, contactperson: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, contactperson: 'Double Space not allowed' }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, contactperson: false }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, contactperson: '' }));
    }
  };
 
  const handletelephonenoChange = (newValue) => {
    const numericValues = handleNumericValue(newValue);

    // Update the telephone number
    setIsChanged(true);
    setTelephoneno(numericValues);

    // Clear the error and error message when a valid value is entered
    if (numericValues) {
      setErrors((prev) => ({
        ...prev,
        telephoneno: false, // Clear error flag for telephone number
      }));

      setErrorMessages((prev) => ({
        ...prev,
        telephoneno: "", // Clear the error message for telephone number
      }));
    }
  };

  const handleemailChange = (newValue) => {
    setIsChanged(true);
    setEmail(newValue);

    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (newValue === '') {
      // Clear errors and messages if the input is empty
      setErrors((prevErrors) => ({ ...prevErrors, email: false }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, email: '' }));
    } else if (!regex.test(newValue)) {
      setErrors((prevErrors) => ({ ...prevErrors, email: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, email: 'Invalid Email format' }));
    } else if (newValue.startsWith(' ')) {
      setErrors((prevErrors) => ({ ...prevErrors, email: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, email: 'Space not allowed at the beginning' }));
    }
    else if (newValue.endsWith(' ')) {
      setErrors((prevErrors) => ({ ...prevErrors, email: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, email: 'Space not allowed at the end' }));
    }
    else if (newValue.includes('  ')) {
      setErrors((prevErrors) => ({ ...prevErrors, email: true }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, email: 'Double Space not allowed' }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, email: false }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, email: '' }));
    }
  };



  const handlecategoryChange = (newValue) => {
    setIsChanged(true);
    setCategory(newValue);

    if (newValue) {
      setErrors((prevErrors) => ({ ...prevErrors, technicalcategory: false }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, technicalcategory: '' }));
    }
  };
  const handletypeChange = (newValue) => {
    setIsChanged(true);
    setType(newValue);


    if (newValue) {
      setErrors((prevErrors) => ({ ...prevErrors, technicaltype: false }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, technicaltype: '' }));
    }
  };

  const handleSave = async () => {

    try {

      const payload = {
        id,
        facilityid: facilityid,
        referenceno: referenceno,
        description: description,
        location: location,
        contactperson: contactperson,
        telephoneno: telephoneno,
        email: email,
        femtechnicalcategoryId: technicalcategory.id,
        femtechnicaltypeId: technicaltype.id,
        isdeleted: false
      };
      let response;
      if (isEdit) {
        //  payload.id = id;
        response = await axios.put(`${FemsGraph}/api/femtechnicaldrawings/${id}`, payload, config);
        setTechnicalType2(technicaltype.label);
        setTechnicalcategory2(technicalcategory.label);
        setDescription2(description);

      } else {
        response = await axios.post(`${FemsGraph}/api/femtechnicaldrawings`, payload, config);
    
        setFemsTechId(response.data.id);
        setTechnicalType2(technicaltype.label);
        setTechnicalcategory2(technicalcategory.label);
        setDescription2(description);

      }

      if (response.status == 201) {
        setOpenValidationDialog(true)
        setDialogContent('Data saved successfully.')
        setIsChanged(false)
      }
      else if (response.status == 200) {
        setOpenValidationDialog(true)
        setDialogContent('Data updated successfully.')
        setIsChanged(false)
      }

    } catch (error) {
      console.error("Error saving Store details:", error);
      if (error.response.status === 400) {

        setDialogContent("Reference No is Already Exists");

      } else {
        setDialogContent("An unexpected error occurred. Please try again later.");
      }
      setOpenValidationDialog(true);

    }
  };

  const handleAdd = () => {
    setReferenceno('');
    setDescription('');
    setLocation('');
    setContactperson('');
    setTelephoneno('');
    setEmail('');
    setCategory(Technicalcategory[0]);
    setType(options[0]);
    setIsEdit(false);
    setIsView(false);
    setErrors({ referenceno: false, description: false, location: false, contactperson: false, telephoneno: false, technicalcategory: false, email: false, technicaltype: false });
    setErrorMessages({ referenceno: '', description: '', location: '', contactperson: '', telephoneno: '', technicalcategory: '', email: '', technicaltype: '' });
  };



  const handleTabChange = (event, newValue) => {
    if (!isEdit && !isView && !femsTechId) {
      setCancelDialogOpenTab(true);
      return;
    }
    setTabValue(newValue);
  };

  useEffect(() => {
    if (technicalcategory && technicalcategory.id) {
      const newFilteredOptions = options.filter(option => option.femtechnicalcategoryId === technicalcategory.id);
      setFilteredOptions(newFilteredOptions);
      // Set the first value as default if available
      if (newFilteredOptions.length > 0) {
        setType(newFilteredOptions[0]); // Set the default value
      } else {
        setType(undefined); // Clear the value if no options are available
      }
    } else {
      setFilteredOptions([]); // Set an empty array or handle this case appropriately
      setType(undefined); // Clear the value if technicalcategory is not valid
    }
  }, [technicalcategory, options]);


  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <PageTitle
        isEdit={isEdit}
        isView={isView}
        editTitle={"Edit FEMS Technical Drawing"}
        viewTitle={"View FEMS Technical Drawing"}
        title={"Create FEMS Technical Drawing"}
      />
      <TabContext value={tabValue}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleTabChange} aria-label="Store Details Tabs">
            <Tab label="FEMS Technical Drawing" value="1" sx={{ minWidth: 120 }} />
            <Tab label="Attachments" value="2" sx={{ minWidth: 200 }} />
          </TabList>

        </Box>


        <TabPanel value="1">
          <DefaultCard>
            <form onSubmit={handleSubmit} style={{ position: "relative" }}>
              <Box mt={2}>
                <Grid container spacing={2}>
                  <Grid item xs={6} md={4}>
                    <CustomTextField
                      maxlength={16}
                      id="referenceno-label"
                      label="Reference No."
                      value={referenceno}
                      onChange={handlereferencenoChange}
                      disabled={readOnly || readOnlyEdit}
                      isMandatoryField={true}
                      error={errors.referenceno}
                      readOnlyEdit={readOnlyEdit}
                      readOnly={readOnly}
                      errorMessage={errorMessages.referenceno}
                      inputRef={serviceRef}
                    />
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <CustomSelectInput
                      label="Category"
                      value={technicalcategory}
                      options={Technicalcategory}
                      getOptionLabel={(option) => option.label}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                      onChange={handlecategoryChange}
                      //  disabled={readOnlyEdit}
                      disabled={readOnly}
                      readOnlyEdit={readOnlyEdit}
                      readOnly={readOnly}
                      error={errors.technicalcategory}
                      errorMessage={errorMessages.technicalcategory}
                    />
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <CustomSelectInput
                      label="	Type"
                      value={technicaltype}
                      options={filteredOptions}
                      onChange={handletypeChange}
                      disabled={readOnly}
                      readOnlyEdit={readOnlyEdit}
                      readOnly={readOnly}
                      error={errors.technicaltype}
                      errorMessage={errorMessages.technicaltype}
                    />
                  </Grid>

                  <Grid item xs={6} md={4}>
                    <CustomTextField
                      maxlength={60}
                      label="Location"
                      id="location"
                      value={location}
                      onChange={handlelocationChange}
                      disabled={readOnly}
                      readOnlyEdit={readOnlyEdit}
                      readOnly={readOnly}
                      isMandatoryField={true}
                      error={errors.location}
                      errorMessage={errorMessages.location}
                    //  inputRef={descRef}
                    />
                  </Grid>

                  <Grid item xs={6} md={4}>
                    <CustomTextField
                      maxlength={20}
                      label="Description"
                      id="person"
                      value={description}
                      onChange={handledescriptionChange}
                      disabled={readOnly}
                      readOnlyEdit={readOnlyEdit}
                      readOnly={readOnly}
                      isMandatoryField={true}
                      error={errors.description}
                      errorMessage={errorMessages.description}
                    />
                  </Grid>

                  <Grid item xs={6} md={4}>
                    <CustomTextField
                      maxlength={120}
                      label="	Contact Person "
                      id="contactperson"
                      value={contactperson}
                      onChange={handlecontactpersonChange}
                      disabled={readOnly}
                      readOnlyEdit={readOnlyEdit}
                      readOnly={readOnly}
                      isMandatoryField={true}
                      error={errors.contactperson}
                      errorMessage={errorMessages.contactperson}
                    />
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <CustomTextField
                      maxlength={20}
                      label="	Telephone No "
                      id="telephoneno"
                      value={telephoneno}
                      onChange={handletelephonenoChange}
                      disabled={readOnly}
                      readOnlyEdit={readOnlyEdit}
                      readOnly={readOnly}
                      isMandatoryField={true}
                      error={errors.telephoneno}
                      errorMessage={errorMessages.telephoneno}
                    />
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <CustomTextField
                      maxlength={120}
                      label="Email Address"
                      id="email"
                      value={email}
                      readOnlyEdit={readOnlyEdit}
                      readOnly={readOnly}
                      onChange={handleemailChange}
                      disabled={readOnly}

                      error={errors.email}
                      errorMessage={errorMessages.email}
                    />
                  </Grid>

                </Grid>

              </Box>

            </form>

          </DefaultCard>
          <CustomFooter
            cancelClick={handleCancel}
            saveClick={handleSubmit}
            addClick={handleAddNew}
            readOnly={readOnly}
            buttonLabel={isEdit ? "Update" : "Save"}
            isEdit={isEdit}
            showAddButton={tabValue === "1"}
          />

        </TabPanel>

        <TabPanel value="2">
          <DefaultCard>
            <form onSubmit={handleSubmit} style={{ position: "relative" }}>
              <Box mt={2}>
                <Grid container spacing={2}>
                  <Grid item xs={6} md={4}>
                    <CustomTextField
                      maxlength={16}
                      id="referenceno"
                      label="Reference No."
                      value={referenceno}
                      readOnlyEdit={readOnlyEdit}
                      readOnly={readOnly}
                      disabled
                      isMandatoryField={true}
                      error={errors.referenceno}
                      errorMessage={errorMessages.referenceno}
                      inputRef={serviceRef}
                    />
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <CustomTextField
                      label="	Type"
                      value={technicalType2}
                      // options={Technicaltype}
                      //  onChange={handletypeChange}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <CustomTextField
                      maxlength={60}
                      label="Description"
                      id="Description"
                      value={description2}
                      disabled
                      isMandatoryField={true}
                      inputRef={descRef}
                    />
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <CustomTextField
                      label="Category"
                      value={technicalcategory2}
                      disabled

                    />
                  </Grid>

                </Grid>


              </Box>


            </form>
            <br />
            <br />
          </DefaultCard>

          <br />
          <br />
          <AttachmentFemsTechDrawing femsTechId={femsTechId} editId={id} viewId={id} isEdit={isEdit} isView={isView} />

        </TabPanel>

      </TabContext>

      <CustomDialog
        open={cancelDialogOpen}
        onConfirm={handleConfirmCancel}
        onClose={handleDialogClose}
        content={dialogContent}
        confirmBtn={'Yes'}
        cancelBtn={'No'}
      />
      <CustomDialog
        open={cancelDialogOpenTab}
        onClose={handleCancelDialogCloseTab}
        content="Please fill out the FEMS Technical Drawing first before proceeding to other tabs."
        confirmBtn="Ok"
        onConfirm={handleConfirmCancelTab}
      />
      <CustomDialog
        open={openValidationDialog}
        onConfirm={handleConfirmCancel}
        onClose={handleDialogClose}
        content={dialogContent}
        confirmBtn={'Ok'}
      />
    </Box>
  );
};

export default CreateFemsDrawing;


